export class TypologieUO {
  constructor(public idTypologieUo: number,
    public libelleCourtTUO: string,
    public libelleLongTUO: string,
    public dateDebutTUO: Date,
    public dateFinTUO?: Date,
  ) { }
} 